<div class="faq-sub-question-title">Billing questions</div>
<section [multiple]="false">
  <div class="padding-vertical pv16 faq-border-bottom">
    <a class="faq-link-item" (click)="closeNonActiveCollapse('zero')" mdbRipple [class.active]="accordianWithMDB.zero">
      <div class="faq-item">
        <div class="faq-item-title">What options are available in the billing section? </div>
        <div class="faq-arrow-block">
          <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.zero" alt="simple down arrow" />
          <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.zero" alt="simple up arrow" />
        </div>
      </div>
    </a>
    <div *ngIf="accordianWithMDB.zero" class="padding-left pl16 " #zero [class.fake-accourdian]="!accordianWithMDB.zero">
      <div class="faq-answ-block">
        In this section, you will find all relevant billing information. The tabs include Overview, Make a Payment, and Documents. In the overview tab, you can use the dropdown menus to view details about both active and inactive policies. Any billing documents you have uploaded will be accessible under the documents tab (currently available for Massachusetts users only). Additionally, payments can be processed directly within this section.
      </div><br>
      <div class="faq-answ-block no-padding">
        This new billing section complements the existing links in your account, so you can continue to navigate as you prefer.
      </div>
    </div>
  </div> 

  <div class="padding-vertical pv16 faq-border-bottom">
    <a class="faq-link-item" (click)=" closeNonActiveCollapse('three')" mdbRipple [class.active]="accordianWithMDB.three">
      <div class="faq-item">
        <div class="faq-item-title">How do I enroll in paperless?</div>
        <div class="faq-arrow-block">
          <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.three" alt="simple down arrow" />
          <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.three" alt="simple up arrow" />
        </div>
      </div>
    </a>
    <div class="padding-left pl16 " #three [class.fake-accourdian]="!accordianWithMDB.three">
      <div class="faq-answ-block">
        To enroll in paperless, use your policy cards, the Billing Details page on the Overview tab, or the <br *ngIf="isLargeScreen"> Account and Settings dropdown under your name.
        </div>
    </div>
  </div>

  <div class="padding-vertical pv16 faq-border-bottom">
    <a class="faq-link-item" (click)=" closeNonActiveCollapse('four')" mdbRipple [class.active]="accordianWithMDB.four">
      <div class="faq-item">
        <div class="faq-item-title">How can I make payments to my policy?</div>
        <div class="faq-arrow-block">
          <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.four" alt="simple down arrow" />
          <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.four" alt="simple up arrow" />
        </div>
      </div>
    </a>
    <div class="padding-left pl16"  #four [class.fake-accourdian]="!accordianWithMDB.four">
      <div class="faq-answ-block">
        You have several convenient ways to make a payment:
      </div><br>
      <div class="faq-answ-block no-padding">
        <div class="faq-answ-block fw-700 no-padding">
          Pay online (recommended)
        </div>
        <ul class="no-margin-bottom padding-left pl16 faq-ul ml12">
          <li>Make a payment or set up autopay (EFT).</li>
          <li>Enroll in autopay for automatic, on-time payments.</li>
        </ul>
      </div><br>
      <div class="faq-answ-block no-padding">
        <div class="faq-answ-block fw-700 no-padding">
          Pay as a guest
        </div>
        <ul class="no-margin-bottom padding-left pl16 faq-ul ml12">
          <li>Make a one-time payment without an account: <a href="https://payments.mapfreinsurance.com" class="mapfre link red-link fw-400-imp faq-text-decoration" target="_blank" rel="noopener">https://payments.mapfreinsurance.com/</a>.</li>
        </ul>
      </div><br>
      <div class="faq-answ-block no-padding">
        <div class="faq-answ-block fw-700 no-padding">
          Pay by phone
        </div>
        <div class="faq-answ-block no-padding">
          Call 855-Mapfre-7 <a href="tel:8556273737" class="mapfre link red-link dm-sans-medium fw-400-imp faq-text-decoration">(855-627-3737)</a>.
        </div>
        <ul class="no-margin-bottom padding-left pl16 faq-ul ml12">
          <li>Automated system: Available 24/7 at no additional cost.</li>
            <ul class="no-margin-bottom padding-left pl16 faq-ul ml12">
              <li class="faq-list-bullet">Say "Make a payment" or press “2” to complete your payment.</li>
            </ul>
        </ul>
        <ul class="no-margin-bottom padding-left pl16 faq-ul ml12">
          <li>Customer service representative: Monday–Friday, 8:00 a.m. – 5:00 p.m. EST.</li>
            <ul class="no-margin-bottom padding-left pl16 faq-ul ml12">
              <li class="faq-list-bullet">Speak with a customer service representative to make a payment.</li>
              <li class="faq-list-bullet">$2.95 service fee applies.</li>
            </ul>
        </ul>
      </div>
    </div>
  </div>

  <div class="padding-vertical pv16 faq-border-bottom">
    <a [routerLink]="['/faq', 'autopay']">
      <div class="faq-item">
        <div class="faq-item-title">Autopay (EFT)</div>
        <div class="faq-arrow-block">
          <img src="assets/img/images/faq-arrow-right.svg" />          
        </div>
      </div>
    </a>    
  </div>
  <div class="padding-vertical pv16 faq-border-bottom">
    <a [routerLink]="['/faq', 'pay-in-full']">
      <div class="faq-item">
        <div class="faq-item-title">Pay in full</div>
        <div class="faq-arrow-block">
          <img src="assets/img/images/faq-arrow-right.svg" />          
        </div>
      </div>
    </a>    
  </div>
</section>
<div class="row margin-top mt24 text-center">
  <div class="col">
    <a routerLink="/faq" class="faq-back"><img src="assets/img/images/faq-icon-strong-arrow-left.svg" class="align-middle pr-1"><p class="faq-back-btn">{{ 'BACK' | translate }}</p></a>
  </div>
</div>